export default "/images/27a7ab4cac4295b18eb2f0f7edc95ff9.avif";